import {TEntity} from '../../models/entity';

export function objectNames(classes: { [key: string]: boolean }): string {
    return Object.entries(classes)
        .filter(([_, value]) => value)
        .map(([key, _]) => key)
        .join(' ');
}

export function getProperty<T, K extends keyof T>(o: T, propertyName: K): T[K] {
    return o[propertyName]; // o[propertyName] is of type T[K]
}

export function getCompositeProperty(obj: any, propertyPath: string) {
    var props = propertyPath.split('.');
    const property = props.reduce((value, prop) => (value || {})[prop], obj);
    return property;
}

export type EnumDictionary<T extends string | symbol | number, U> = {
    [K in T]: U;
};

export function setPropValue<T>(item: T, propName: string, value: any): T {
    const separatorIdx = propName.indexOf('.');
    if (separatorIdx > 0) {
        const first = propName.substring(0, separatorIdx);
        const rest = propName.substring(separatorIdx + 1);

        return {
            ...item,
            [first]: setPropValue((item as any)[first], rest, value),
        };
    }
    return {
        ...item,
        [propName]: value,
    };
}

export function sortAlphabeticallyAscending(a: { navn: string }, b: { navn: string }) {
    return a.navn.localeCompare(b.navn);
}


export function setListItemPropValue<T extends TEntity>(prevValue: T[], rowId: string | number, propName: string, value: any) {
    let newList = [...prevValue];
    const index = newList.findIndex(m => m.id === rowId);
    if (index >= 0) {
        let patch = (newList as any).at(index);
        if (patch) {
            newList[index] = setPropValue(patch, propName, value);
        }
    }
    return newList;
}

export function setListItemValue<T extends TEntity>(prevValue: T[], rowId: string | number, value: any) {
    let newList = [...prevValue];
    const index = newList.findIndex(m => m.id === rowId);
    if (index >= 0) {
        newList[index] = value;
    }
    return newList;
}


export function isEmpty(obj: object | undefined | null): boolean {
    if (typeof obj === 'undefined' || obj === null) return true;
    return Object.values({...obj}).every((x) => !x || (typeof x === 'string' && x.length === 0) || (typeof x === 'object' && isEmpty(x)));
}

export function isValidJSON(str: string) {
    if (!str) return false;
    return /^[\],:{}\s]*$/.test(str.replace(/\\["\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''));
}